import { render, staticRenderFns } from "./RequiresFurtherAttention.vue?vue&type=template&id=4fe6421d&"
import script from "./RequiresFurtherAttention.vue?vue&type=script&lang=js&"
export * from "./RequiresFurtherAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports